// extracted by mini-css-extract-plugin
export default {"ContentContainer":"ContentContainer_ContentContainer__JN91c"};